import type { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

/** Một nhóm ô trong form, có tiêu đề và một dòng mô tả tuỳ chọn. */
export function Nhom({
  tieuDe,
  moTa,
  children,
}: {
  tieuDe: string;
  moTa?: string;
  children: ReactNode;
}) {
  return (
    <fieldset className="space-y-3">
      <legend className="text-sm font-semibold text-content-primary">{tieuDe}</legend>
      {moTa && <p className="-mt-1 text-xs leading-relaxed text-content-muted">{moTa}</p>}
      {children}
    </fieldset>
  );
}

/**
 * Điều người dùng cần biết **trước** khi bấm, không phải lỗi: hồ sơ còn thiếu,
 * hoặc việc sắp chạy sẽ dừng lại chờ một người khác. Tông cảnh báo chứ không
 * phải tông lỗi, vì chưa có gì hỏng.
 */
export function CanhBaoTrongHop({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-start gap-2 rounded border border-warning-200 bg-warning-50 px-3 py-2.5">
      <AlertTriangle size={15} className="mt-0.5 shrink-0 text-warning-600" />
      <div className="min-w-0 text-xs leading-relaxed text-warning-700">{children}</div>
    </div>
  );
}

/**
 * Lỗi của lần gửi vừa rồi, hiện **trong** hộp thoại và hộp không đóng: dữ liệu
 * vừa nhập còn nguyên để sửa. Đóng hộp rồi báo bằng toast là bắt người dùng
 * nhập lại từ đầu.
 */
export function LoiTrongHop({ children }: { children: ReactNode }) {
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded border border-danger-200 bg-danger-50 px-3 py-2.5 text-left"
    >
      <AlertTriangle size={15} className="mt-0.5 shrink-0 text-danger-600" />
      <span className="min-w-0 text-xs leading-relaxed text-danger-700">{children}</span>
    </div>
  );
}
